import React from "react"

import { Container } from "./styles"

const HeroWrapper = ({ children }) => <Container>{children}</Container>

export default HeroWrapper
